import { matchPath } from 'react-router';
import { csrdRoutePaths } from 'core/lib/routePaths/csrdRoutePaths';

export const CSRD_LAST_SUBPAGE_ENTITY_KEY = 'CSRD.LAST_SUBPAGE';

export type CsrdLastSubpage = {
  path: string;
};

export const isRestorableCsrdPath = (
  path: string | undefined,
  options: { overviewEnabled: boolean },
): path is string => {
  if (!path) {
    return false;
  }

  const patterns = [csrdRoutePaths.HOME, csrdRoutePaths.PRICING, `${csrdRoutePaths.ABOUT}/*`];

  if (options.overviewEnabled) {
    patterns.push(csrdRoutePaths.OVERVIEW);
  }

  return patterns.some((pattern) => !!matchPath(pattern, path));
};
